module.exports = __webpack_public_path__ + "img/img2.0f69c7b.png";